import React from "react";
import Card from "react-bootstrap/Card";


function ProjectCards(props) {



  const goDemo = (link) => {
    
    window.open(link, "_blank");

  }

  return (
    <Card className="project-card-view" onClick={()=> goDemo(props.demoLink)}>
      <Card.Img variant="top" src={props.imgPath} alt="card-img" />
      <Card.Body>
          <Card.Title> <strong>{props.title}</strong> </Card.Title>
          <Card.Text style={{ textAlign: "justify" }}>
            {props.description}
          </Card.Text>
          <Card.Text style={{ textAlign: "justify" }}>
            <strong>{props.stack}</strong>
          </Card.Text>
     
      </Card.Body>
    </Card>
  );
}
export default ProjectCards;
